import { render, staticRenderFns } from "./askToRemoveAcc.vue?vue&type=template&id=db973a12&scoped=true"
import script from "./askToRemoveAcc.vue?vue&type=script&lang=js"
export * from "./askToRemoveAcc.vue?vue&type=script&lang=js"
import style0 from "./askToRemoveAcc.vue?vue&type=style&index=0&id=db973a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db973a12",
  null
  
)

export default component.exports